import React from 'react';
import styled from 'styled-components';
import { FaRegFile } from "react-icons/fa";
import Button from "../parts/Button";
import { GetUserSession200Response } from "../../../api/v1";
import { useNavigate } from "react-router-dom";

type NoteShopComponentProp = {
  cafeNoteId?: number
  shopId: number
  shopName?: string
  session: GetUserSession200Response
}

const CafeNoteButtonStyle = styled(Button)`
  display: flex;
  align-items: center;
  background: #393432;
  justify-content: center;
  margin-bottom: 15px;

  svg {
    font-size: 20px;
  }

  &:hover {
    background: #696767;
  }
`;

const CafeNoteButton: React.FC<NoteShopComponentProp> = ({ shopId, shopName, session }) => {
  const navigate = useNavigate();

  const onCafeNote = (event) => {
    event.preventDefault();
    if (session) {
       return navigate(`/user/cafe-notes/create?shop_id=${shopId}&shop_name=${shopName}`);
    } else {
      window.alert('ログインすると、カフェノートを記録することができます。');
    }
  };

  return (
    <CafeNoteButtonStyle onClick={event => onCafeNote(event)} ariaLabel='カフェノートボタン'>
      <FaRegFile />
    </CafeNoteButtonStyle>
  );
};

export default CafeNoteButton;
